import { fg } from '@atlaskit/platform-feature-flags/fg';
import { navigateToTeamsApp } from '@atlaskit/teams-app-config/navigation';

// TODO: Remove this once each product passes this value via the generateUserUrl prop
export const getUserPath: (
	userId: string,
	primaryProduct: string,
	orgId: string,
	cloudId: string,
) => string | undefined = (
	userId: string,
	primaryProduct: string,
	orgId: string,
	cloudId: string,
) => {
	if (primaryProduct === 'confluence') {
		return fg('platform-adopt-teams-nav-config')
			? navigateToTeamsApp({
					type: 'USER',
					payload: {
						userId,
					},
					cloudId,
					hostProduct: 'confluence',
				}).href
			: `/wiki/people/${userId}`;
	} else if (primaryProduct === 'townsquare') {
		return fg('platform-adopt-teams-nav-config')
			? navigateToTeamsApp({
					type: 'USER',
					payload: {
						userId,
					},
					cloudId,
					hostProduct: 'home',
				}).href
			: `/o/${orgId}/people/${userId}?cloudId=${cloudId}`;
	}
};
